
































































import { Component, Vue } from 'vue-property-decorator';
import { date } from 'quasar';
import formatDate = date.formatDate;
import PeopleInput from '@/components/PeopleInput.vue';
import { Action, Mutation, State } from 'vuex-class';
import { QueryState } from '@/store/query/types';

@Component({
  components: { PeopleInput },
})
export default class RoomSearchBar extends Vue {
  @State('query') query!: QueryState;
  @Mutation('query/updateQuery') updateQuery!: any;
  @Action('query/fetchQuery') fetchQuery!: any;
  formatDate = formatDate;

  get datePickerColumns() {
    return window.innerWidth > 540 ? 2 : 1;
  }

  get checkInDates() {
    return {
      start: this.query.checkInDate,
      end: this.query.checkOutDate,
    };
  }

  set checkInDates(value: any) {
    this.updateQuery({
      checkInDate: value.start,
      checkOutDate: value.end,
    });
  }

  get people() {
    return {
      adults: this.query.adults,
      children: this.query.children,
    };
  }

  set people(value: { adults: number; children: number[] }) {
    this.updateQuery({
      adults: value.adults,
      children: value.children,
    });
  }

  getInputDate(value: any = '', index: number) {
    return value.split(' - ')[index];
  }

  created() {
    this.fetchQuery();
  }
}
